module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    class: 'builder-list-popover ' + _vm.className,
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction,
      "tipColor": _vm.tipColor
    }
  }, _vm._l((_vm.list), function(option) {
    return _c('div', {
      staticClass: "builder-list-popover__option",
      class: _vm.optionClass(option),
      style: (_vm.optionStyle),
      attrs: {
        "id": ("popover-box-option-" + (option.name))
      },
      on: {
        "click": function (e) { return _vm.selectOption(option.value, option, e); }
      }
    }, [_vm._v("\n    " + _vm._s(option.name) + "\n  ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4135011e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/builderComponents/ListPopover.vue
// module id = 1875
// module chunks = 0